import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const updateCompany = {
    namespaced: true,
    state: {
        updateIsFetching: false,
        modalDataUpdate: {},
        isCompanyUpdate: false
    },
    mutations: {
        UPDATE_COMPANY_SUCCESS(state, response) {
            localStorage.setItem("messageSaveCompany", response.data.message);
            localStorage.setItem("textSaveCompany", response.data.data.textInfo);

            window.location.href = "/companies";
        },
        UPDATE_COMPANY_FAILURE(state, error) {
            eventBus.$emit("storeDataFailure", error.response.data.errors);
            state.modalDataUpdate.textInfoCompanyUpdate = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.modalDataUpdate.typeInfoCompanyUpdate = "red";
            state.modalDataUpdate.headInfoCompanyUpdate = error.response.data.message;
            state.isCompanyUpdate = true;
        },
        UPDATE_VISIBLE_MODAL_UPDATE(state, value) {
            state.isCompanyUpdate = value;
        }
    },
    actions: {
        updateCompany({dispatch, state}, payload) {
            const urlParams = new URLSearchParams(window.location.search);

            state.updateIsFetching = true;

            let promise = sendRequest("put", config.baseURLApi + "/companies/" + urlParams.get("companyId"), {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successUpdateCompany", result[1]);
                } else {
                    dispatch("failureUpdateCompany", result[1]);
                }
                state.updateIsFetching = false;
            });
        },
        updateVisibleModalUpdate({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL_UPDATE", value);
        },
        successUpdateCompany({ commit }, response) {
            commit("UPDATE_COMPANY_SUCCESS", response);
        },
        failureUpdateCompany({ commit }, error) {
            commit("UPDATE_COMPANY_FAILURE", error);
        }
    }
}

export default updateCompany;